import { AbstractControl, ValidatorFn } from '@angular/forms';

export function noWhitespaceAllowedValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const hasWhitespace = /\s/.test(control.value);
    return hasWhitespace ? { whitespace: true } : null;
  };
}
